function DesktopShortcuts({ apps, onOpenApp }) {
  return (
    <nav className="desktop-shortcuts" aria-label="Desktop shortcuts">
      {apps.map((app) => (
        <button
          key={app.id}
          type="button"
          className="shortcut"
          onClick={() => onOpenApp(app.id)}
        >
          {app.icon ? (
            <img src={app.icon} alt="" className="shortcut-icon" />
          ) : (
            <span className={`shortcut-icon accent-${app.accent}`} />
          )}
          <span className="shortcut-label">{app.menuLabel}</span>
        </button>
      ))}
    </nav>
  );
}

export default DesktopShortcuts;
